/**
 * List of supported Ad Providers
 * @param options object of options to build the list
 * @param options.includeEmpty boolean to include an empty name/value pair at the beginning
 * @param options.emptyData object of data to spread into the empty name/value pair if includeEmpty is true
 */
export function list(options = {}) {
  const list = [
    {
      label: 'Good Vibes',
      value: 'goodvibes',
      alwaysOnPmp: false,
      programmatic: false,
    },
    {
      label: 'Koddi',
      value: 'koddi',
      alwaysOnPmp: true,
      programmatic: true,
    },
    {
      label: 'Triton',
      value: 'triton',
      alwaysOnPmp: false,
      programmatic: false,
    },
    {
      label: 'Vibenomics',
      value: 'vibenomics',
      alwaysOnPmp: false,
      programmatic: false,
    },
    {
      label: 'Vistar',
      value: 'vistar',
      alwaysOnPmp: true,
      programmatic: true,
    },
  ];

  if (options.includeEmpty === true) {
    const emptyData = options.emptyData ?? {};

    list.unshift({
      label: '',
      value: '',
      ...emptyData,
    });
  }

  return list;
}

export default {
  list,
};
